export var CustomStrategy = {
  info: {
    Name: 'Custom'
  }
};